import { React, useState, useEffect, useRef, useLayoutEffect } from "react";
import { TabBar, SafeArea, Popup, Mask } from 'antd-mobile'
import { UnorderedListOutline, CalendarOutline, FilterOutline, UserOutline } from 'antd-mobile-icons'
import styles from "./Main.module.css"
import Book from "./Book/Book.js";
import My from "./My/My.js"
import Filter from "./Filter/Filter.js"
import Loading from "./Loading.js"
import AddGramma from "./Add/AddGramma.js";
import AddWord from "./Add/AddWord.js"
import EditGramma from "./Edit/EditGramma.js"
import EditWordJP from "./Edit/EditWordJP.js"
import { RegistLoading } from "../../utils/EventBus.js";
import http from "../../utils/http.js";

const states = require("../../utils/states.js")

var _firstInit = true;
var _curLoadingCalls = 0;
var _editGramma = false;
var _editID = 0;
var _curEditGramma = {}
var _curEditWord = {}
var _bNeedScrollBtm = false


export default function Main() {
  const [loading, setLoading] = useState(false)
  const [bAddPanel, setAddPanel] = useState(false)
  const ref_book = useRef(null)

  async function initialBooks() {

    await states.InitDownloadBook();
    refreshList();
  }
  useLayoutEffect(() => {
    if (_bNeedScrollBtm) {
      ref_book.current.scrollBottom()
      _bNeedScrollBtm = false
    }
  }, [bAddPanel])

  if (_firstInit) {
    RegistLoading((bLoading) => {
      if (bLoading) {
        _curLoadingCalls += 1;
      } else {
        _curLoadingCalls -= 1;
      }
      console.log('Main.js:有人叫了LoadingMask,目前呼叫数目为:', _curLoadingCalls)
      setLoading(_curLoadingCalls > 0)
    })
    initialBooks()
    _firstInit = false;
  }
  //#region 底部Tab相关
  const [curPage, setCurPage] = useState('book')
  const [bCardMode, setBCardMode] = useState(false)
  const clickBook = (value) => {//这里的value是key的值，如 /modelist
    console.log("clickBook!")
    if (curPage === 'book') { //当前是book页，不切换页,但切换模式
      setBCardMode(!bCardMode)
    } else { //当前不是book页，切换页，不切换模式
      setCurPage('book')
    }
  }
  const clickFilter = (value) => {
    console.log("click Filter! value = " + value)
    setFilterVisible(prev => !prev)
  }

  const clickMy = (value) => {
    setCurPage('my')
  }
  //#endregion
  //#region Filter
  const [filterVisible, setFilterVisible] = useState(false)
  const onFilterOver = () => {
    console.log("onFilterOver()")
    setFilterVisible(false)
  }
  //#endregion
  //#region 添加面板相关
  function CallAddGrammaPanel(onAfterAdd) {
    setAddPanel(true);
    onAfterAdd?.();
  }

  function addGrammaSubmit(gramma) {
    if (gramma === null) {
      setAddPanel(false)
    } else {
      //告诉states,要AddGramma了
      states.UploadNewGramma(gramma, (b) => {
        if (b) {//成功
          //把刚刚那条添加进列表，重新渲染
          ref_book.current?.refreshAfterAdd();
          //把滚动条滚到底
          _bNeedScrollBtm = true
          setAddPanel(false)

        }
      })
    }
  }

  function CallAddWordPanel(onAfterAdd) {
    setAddPanel(true);
    onAfterAdd?.();
  }
  function addWordSubmit(word) {
    console.log("main::on add word submit ,word = ", word)
    if (word === null) {
      setAddPanel(false)
    } else {
      //告诉states,要AddGramma了
      states.addWord(word, (b) => {
        console.log('添加完成回调，b=', b)
        if (b) {//成功
          //把刚刚那条添加进列表，重新渲染
          ref_book.current?.refreshAfterAdd();
          //把滚动条滚到底
          _bNeedScrollBtm = true
          setAddPanel(false)
        }
      })
    }
  }

  //#endregion
  //#region 编辑面板相关
  function CallEditWordPanel(id, listOrder) {
    console.log('编辑按钮被按了!word.id = ', id, ' listOrder = ', listOrder)
    _editID = listOrder
    CallEditWord(true, id)
  }
  async function CallEditWord(bOpen, id) {
    if (states.getCurSelectedBook() === -1) {
      _editGramma = true
    } else {
      _editGramma = false
    }
    var re = await http.get('/word/getbyid', { params: { id: id } });
    console.log('编辑word,下载结果 = ', re.data.word)
    _curEditWord = structuredClone(re.data.word)
    //初始化add list wrap
    const initLists = (wrap, former) => {
      wrap.listAdd = []
      var totalC = wrap.list.length
      for (let i = 1; i < totalC; i++) {
        let item = wrap.list[i]
        wrap.listAdd.push({ key: i - 1, name: item.name, selected: false })
      }
      if (former && former.length > 0) {
        let formerSet = new Set(former);
        //把已经有的选项选上去
        // console.log('formerSet = ',formerSet,'listAdd = ',wrap.listAdd)

        wrap.listAdd.forEach(item => item.selected = formerSet.has(item.name))
      }
    }
    console.log('编辑面板：清空tag的addlist列表,当前word的tags:', _curEditWord.tags)
    initLists(states.wordTagWrap, _curEditWord.tags)
    setEditPanel(bOpen)
  }
  function EditWordSubmit(word, order) {
    if (word === null) {
      setEditPanel(false)
    } else {
      states.UpdateWord(word, async (b) => {
        if (b) {//成功，TODO 1 下载更新tag，2 更新这一条gramma，3 关闭面板
          // await states.downloadGrammaBook()
          // await states.downloadGrammaTags()
          states.downloadWordTagByBook();
          refreshItem(order)
          EditWordSubmit(null)
        } else {//失败，啥都不干

        }
      })
    }
  }
  const [editPanel, setEditPanel] = useState(false)
  function CallEditGrammaPanel(id, listOrder) {
    console.log('编辑按钮被按了!gramma.id = ', id, ' listOrder = ', listOrder)
    _editID = listOrder
    CallEditPanel(true, id)
  }
  async function CallEditPanel(bOpen, id) {
    if (states.getCurSelectedBook() === -1) {
      _editGramma = true
    } else {
      _editGramma = false
    }
    var re = await http.get('/gramma/byid', { params: { id: id } });
    console.log('编辑gramma 下载结果 = ', re.data.result)
    _curEditGramma = structuredClone(re.data.result)
    //初始化add list wrap
    const initLists = (wrap, former) => {
      wrap.listAdd = []
      var totalC = wrap.list.length
      for (let i = 1; i < totalC; i++) {
        let item = wrap.list[i]
        wrap.listAdd.push({ key: i - 1, name: item.name, selected: false })
      }
      if (former && former.length > 0) {
        let formerSet = new Set(former);
        //把已经有的选项选上去
        // console.log('formerSet = ',formerSet,'listAdd = ',wrap.listAdd)
        wrap.listAdd.forEach(item => item.selected = formerSet.has(item.name))
      }
    }
    console.log('清空新建tag列表,roooots:', _curEditGramma)
    initLists(states.rootTagsWrap, _curEditGramma.roots)
    initLists(states.prepTagsWrap, _curEditGramma.preps)
    initLists(states.formTagsWrap, _curEditGramma.forms)

    setEditPanel(bOpen)
  }
  function EditGrammaSubmit(gramma, order) {
    if (gramma === null) {
      setEditPanel(false)
    } else {
      states.UpdateGramma(gramma, async (b) => {
        if (b) {//成功，1 下载更新tag，2 更新这一条gramma，3 关闭面板
          await states.downloadGrammaBook()
          await states.downloadGrammaTags()
          // refreshList()
          refreshItem(order)
          EditGrammaSubmit(null)
        } else {//失败，啥都不干

        }
      })
    }
  }
  //#endregion
  const funcs = {
    AddGramma: CallAddGrammaPanel,
    EditGramma: CallEditGrammaPanel,
    AddWord: CallAddWordPanel,
    EditWord: CallEditWordPanel,
  }
  function refreshList() {
    console.log('MAIN::REFRESH LIST')
    ref_book.current?.refreshList()
  }
  function refreshItem(index) {
    console.warn('idx ', index)
    ref_book.current?.refreshItem(index)
  }
  const [reTrig, setRetrig] = useState(0)
  useLayoutEffect(() => {
    setCurPage('book')
  }, [reTrig])
  function reInitList() {
    refreshList()
    setCurPage('no')
    setRetrig(reTrig + 1)
  }
  function closeFilterPanel() {
    setFilterVisible(false)
  }
  const filterFunc = {
    RefreshList: reInitList,
    CloseFilterPanel: closeFilterPanel,
  }
  return (
    <div className={styles.app}>
      {/* 上面部分,主要内容 */}
      <div className={styles.mainBody}>
        {(curPage === 'book') && <Book ref={ref_book} card={bCardMode} funcs={funcs} />}
        <Popup visible={filterVisible}
          onMaskClick={onFilterOver}
          bodyStyle={{ height: '60vh' }}>
          <div style={{ padding: '24px' }}>
            <Filter filterFunc={filterFunc} needRender={filterVisible} />
          </div>
        </Popup>
        {(curPage === 'my') &&
          <My style={{ 'background-color': 'red' }} username={states.getUsername()} />
        }
      </div>
      {/* 底边TabBar选项条 */}
      <div className={styles.bottom}>
        <TabBar activeKey={curPage}>
          <TabBar.Item
            key="book"
            icon={bCardMode ? <CalendarOutline /> : <UnorderedListOutline />}
            title={bCardMode ? '卡片模式' : '列表模式'}
            onClick={value => clickBook(value)}
          />
          <TabBar.Item
            key="filter"
            icon={<FilterOutline />}
            title="删选"
            onClick={value => clickFilter(value)}
          />
          <TabBar.Item
            key="my"
            icon={<UserOutline />}
            title="我的"
            onClick={value => clickMy(value)}
          />
        </TabBar>
      </div>
      {/* 最底边SafeArea */}
      <div className={styles.safeArea}>
        <SafeArea position='bottom' />
      </div>
      {/* 添加gramma界面 */}
      <div>
        {bAddPanel &&
          <Mask style={{ height: '100%' }} visible={bAddPanel} color='rgb(41, 41, 41)' >

            {states.getCurSelectedBook() === -1 ?
              <AddGramma submit={addGrammaSubmit} /> :
              <AddWord submit={addWordSubmit} />}

          </Mask>}
      </div>
      {/* 编辑gramma界面 */}
      <div>
        {editPanel &&
          <Mask visible={editPanel} color='rgb(41, 41, 41)' >
            {_editGramma ?
              <EditGramma funcs={funcs} gramma={_curEditGramma} order={_editID}
                submit={EditGrammaSubmit} />
              : <EditWordJP funcs={funcs} word={_curEditWord} order={_editID}
                submit={EditWordSubmit} />
            }
          </Mask>}
      </div>
      {/* Loading遮罩 */}
      <div>
        <Loading visible={loading} />
      </div>
    </div >
  )
}
